"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsDlaTree = void 0;
var react_1 = __importDefault(require("react"));
var stopToggleOnLinkClick = function (event) {
    event.stopPropagation();
};
exports.WsDlaTree = function (_a) {
    var data = _a.data;
    var epic = data.epic;
    return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-dla-tree", "aria-label": "DLA work item tree" },
        react_1.default.createElement("details", { open: true, className: "ws-ai-hub-use-case-details-dla-tree-node ws-ai-hub-use-case-details-dla-tree-node--epic" },
            react_1.default.createElement("summary", { className: "ws-ai-hub-use-case-details-dla-tree-summary ws-ai-hub-use-case-details-dla-tree-summary--epic" },
                react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-dla-badge ws-ai-hub-use-case-details-dla-badge--epic" }, "Epic"),
                react_1.default.createElement("a", { href: epic.url, target: "_blank", rel: "noreferrer", onClick: stopToggleOnLinkClick },
                    "#",
                    epic.id,
                    " ",
                    epic.label)),
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-dla-tree-children ws-ai-hub-use-case-details-dla-tree-children--epic" }, epic.features.map(function (feature) { return (react_1.default.createElement("details", { key: feature.id, open: true, className: "ws-ai-hub-use-case-details-dla-tree-node ws-ai-hub-use-case-details-dla-tree-node--feature" },
                react_1.default.createElement("summary", { className: "ws-ai-hub-use-case-details-dla-tree-summary ws-ai-hub-use-case-details-dla-tree-summary--feature" },
                    react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-dla-badge ws-ai-hub-use-case-details-dla-badge--feature" }, "Feature"),
                    react_1.default.createElement("a", { href: feature.url, target: "_blank", rel: "noreferrer", onClick: stopToggleOnLinkClick },
                        "#",
                        feature.id,
                        " ",
                        feature.label)),
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-dla-tree-children ws-ai-hub-use-case-details-dla-tree-children--feature" }, feature.stories.map(function (story) { return (react_1.default.createElement("div", { key: story.id, className: "ws-ai-hub-use-case-details-dla-tree-row ws-ai-hub-use-case-details-dla-tree-row--story" },
                    react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-dla-badge ws-ai-hub-use-case-details-dla-badge--story" }, "Story"),
                    react_1.default.createElement("a", { href: story.url, target: "_blank", rel: "noreferrer" },
                        "#",
                        story.id,
                        " ",
                        story.label))); })))); })))));
};
